export const API_URL = window.__env__.API_URL;
export const PREDICT_API_URL = window.__env__.PREDICT_API_URL;
export const PREDICT_TRIAL_PERIOD_HOURS = window.__env__.PREDICT_TRIAL_PERIOD_HOURS;
